/**
 * @name downloadFileFromUrl
 * @param {string} url - URL do arquivo para download
 * @param {string} fileName - Nome do arquivo (opcional)
 * @description Cria um link temporário e dispara o download de um arquivo a partir de uma URL
 */
export const downloadFileFromUrl = (url, fileName = "") => {
  if (!url) {
    console.error("URL não fornecida para download");
    return;
  }

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

/**
 * @name downloadBase64File
 * @param {string} base64File - Arquivo em base64
 * @param {string} fileName - Nome do arquivo
 * @param {string} mimeType - Tipo MIME do arquivo
 * @description Converte um arquivo base64 em blob e dispara o download
 */
export const downloadBase64File = (
  base64File,
  fileName = "export.xlsx",
  mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
) => {
  if (!base64File) {
    console.error("Arquivo base64 não fornecido");
    return;
  }

  // converter Base64 para bytes
  const byteCharacters = atob(base64File);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // criar blob
  const blob = new Blob([byteArray], { type: mimeType });

  // criar URL e disparar download
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
